var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-search-contain"},[_c('app-auto-complete',{attrs:{"placeholder":_vm.$t('app.search'),"fetchSuggestions":_vm.fetchSuggestions,"renderItemText":_vm.renderItemText},on:{"selected":_vm.selectedItem}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a74ec2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/global-search/index.vue
// module id = ZtM3
// module chunks = 23